var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgWriteNotes = function SvgWriteNotes(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 160,
    height: 160,
    viewBox: "0 0 160 160"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h160v160H0z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 86,
    height: 51,
    x: 33.108,
    y: 79.81,
    fill: "#E3EBF4",
    rx: 2,
    transform: "rotate(-7 76.108 105.31)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(7 -131.023 294.398)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#7E9FFB",
    d: "M70 0a2 2 0 0 1 2 2v4h12a2 2 0 0 1 2 2v98a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h12V2a2 2 0 1 1 4 0v4h3V2a2 2 0 1 1 4 0v4h36V2a2 2 0 1 1 4 0v4h3V2a2 2 0 0 1 2-2"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 5,
    x: 12,
    y: 29,
    fill: "#C1D8FD",
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 5,
    x: 12,
    y: 44,
    fill: "#C1D8FD",
    rx: 1
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#F80",
    fillRule: "nonzero",
    d: "M130.641 53.479a2 2 0 0 1 2.829 0l5.657 5.657a2 2 0 0 1 0 2.828l-40.842 40.841-15.403 8.272a1 1 0 0 1-1.354-1.354L89.8 94.32z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 35.594,
    cy: 8.067,
    r: 4.8,
    fill: "#E3EBF4"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10.42,
    cy: 13.84,
    r: 2.4,
    fill: "#F80",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.4,
    cy: 38.082,
    r: 3.2,
    fill: "#7E9FFB"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 139.4,
    cy: 153.4,
    r: 2.4,
    fill: "#F80",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 153,
    cy: 130.2,
    r: 3.2,
    fill: "#7E9FFB"
  }))));
};
export default SvgWriteNotes;